<template>
<div class="card">
  <h5 class="card-header">
    <div class="d-flex align-items-center" style="gap: 10px;">
      <span>Suggested Carriers</span>
      <select v-model="radius" class="form-control form-control-sm radius-select" @change="handleFetch">
        <option v-for="r in radiusOptions" :key="r" :value="r">{{ r }} mi</option>
      </select>
      <i class="fa fa-info-circle text-muted" style="cursor: help; font-size: 24px;"
        v-b-tooltip.hover.top="`Shows carriers who have completed similar routes within ${radius} miles (in both pickup and delivery directions).`"/>
    </div>
  </h5>

  <div class="card-body d-flex flex-column" style="gap: 16px;">
    <div v-if="loading" class="text-center py-3 text-muted">
      <i class="fas fa-spinner fa-spin"></i> Loading...
    </div>

    <div v-else-if="!suggested_carriers.length" class="text-center text-muted py-3">
      No carriers found with similar route experience
    </div>

    <div v-else class="list-group">
      <div v-for="(carrier, index) in suggested_carriers" :key="carrier.id" class="list-group-item border-0 p-0">
        <div>
          <div class="mb-2" style="display: table; width: 100%;">
            <a :href="`/carriers/view/${carrier.id}`" class="text-primary" target="_blank" style="display: table-cell; word-break: break-word;">
              {{ carrier.company }}
            </a>
            <div style="display: table-cell; white-space: nowrap; text-align: right;">
              <i class="fas fa-phone-alt text-secondary"></i>
              <a :href="`tel:${carrier.phone}`" class="text-primary">{{ carrier.phone | formatPhone }}</a>
            </div>
          </div>
          <LabeledData label="Similar Routes" :value="carrier.orderCount + (carrier.orderCount > 1 ? ' orders' : ' order')"/>
          <LabeledData label="Last" :value="formatDate(carrier.signedAt)" :externalLink="'/orders/view/' + carrier.leadId"/>
        </div>
        <hr v-if="index !== suggested_carriers.length - 1" class="my-2" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import LabeledData from '@/components/shared/LabeledData.vue';
import { ApiClient } from '@/api/ApiClient';
import moment from 'moment'

export default {
  name: 'SecurityValidation',
  components: {
    LabeledData
  },
  props: {
    lead_id: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      suggested_carriers: [],
      loading: false,
      radius: 50,
      radiusOptions: [25, 50, 100, 150]
    };
  },
  mounted() {
    this.handleFetch();
  },
  methods: {
    async handleFetch(){
      this.loading = true
      const response = await ApiClient.leads.suggestedCarriers.get({ leadId: this.lead_id, params: { radius: this.radius } })
      this.loading = false
      if(response.status === 200){
        this.suggested_carriers = response.data.data
      }
    },
    formatDate(date) {
      if(date)
        return moment(date).format('D. MMM YYYY')
      return date
    },
  },
};
</script>
<style lang="scss" scoped>
.main-status-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.text-wrap {
  word-wrap: break-word;
  word-break: break-all;
}

.list-group {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 6px;
}

.radius-select {
  width: auto;
  display: inline-block;
  padding: 2px 8px;
  font-size: 13px;
  height: auto;
}

</style>

<style>
#dropdown-info-sugg-carriers .btn-link.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 !important;
  height: 20px;
  width: 20px;
}
</style>
